import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, toPathString, serializeDataIfNeeded } from './common.js';
import { BaseAPI, BASE_PATH } from './base.js';

/* tslint:disable */
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary PATCH cart-api/v2/cart/add-coupon/{couponCode}
         * @param {string} couponCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCoupon: async (couponCode, options = {}) => {
            // verify required parameter 'couponCode' is not null or undefined
            assertParamExists('addCoupon', 'couponCode', couponCode);
            const localVarPath = `/cart-api/v2/cart/add-coupon/{couponCode}`
                .replace(`{${"couponCode"}}`, encodeURIComponent(String(couponCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary PATCH cart-api/v2/cart/{sid}/add-coupon/{couponCode}
         * @param {string} sid
         * @param {string} couponCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCouponWithSid: async (sid, couponCode, options = {}) => {
            // verify required parameter 'sid' is not null or undefined
            assertParamExists('addCouponWithSid', 'sid', sid);
            // verify required parameter 'couponCode' is not null or undefined
            assertParamExists('addCouponWithSid', 'couponCode', couponCode);
            const localVarPath = `/cart-api/v2/cart/{sid}/add-coupon/{couponCode}`
                .replace(`{${"sid"}}`, encodeURIComponent(String(sid)))
                .replace(`{${"couponCode"}}`, encodeURIComponent(String(couponCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary PATCH cart-api/v2/cart/{sid}/add-savingsplan-article/{articleId}
         * @param {string} sid
         * @param {string} articleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSavingsPlanArticle: async (sid, articleId, options = {}) => {
            // verify required parameter 'sid' is not null or undefined
            assertParamExists('addSavingsPlanArticle', 'sid', sid);
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('addSavingsPlanArticle', 'articleId', articleId);
            const localVarPath = `/cart-api/v2/cart/{sid}/add-savingsplan-article/{articleId}`
                .replace(`{${"sid"}}`, encodeURIComponent(String(sid)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary PATCH cart-api/v2/cart/{sid}/set-article-quantity-command
         * @param {string} sid
         * @param {ChangeArticleQuantityRequestV2} changeArticleQuantityRequestV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeArticleQuantity: async (sid, changeArticleQuantityRequestV2, options = {}) => {
            // verify required parameter 'sid' is not null or undefined
            assertParamExists('changeArticleQuantity', 'sid', sid);
            // verify required parameter 'changeArticleQuantityRequestV2' is not null or undefined
            assertParamExists('changeArticleQuantity', 'changeArticleQuantityRequestV2', changeArticleQuantityRequestV2);
            const localVarPath = `/cart-api/v2/cart/{sid}/set-article-quantity-command`
                .replace(`{${"sid"}}`, encodeURIComponent(String(sid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(changeArticleQuantityRequestV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary DELETE cart-api/v2/cart/{sid}/delete-savingsplan-article
         * @param {string} sid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSavingsPlanArticle: async (sid, options = {}) => {
            // verify required parameter 'sid' is not null or undefined
            assertParamExists('deleteSavingsPlanArticle', 'sid', sid);
            const localVarPath = `/cart-api/v2/cart/{sid}/delete-savingsplan-article`
                .replace(`{${"sid"}}`, encodeURIComponent(String(sid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GET cart-api/v2/cart/{sid}
         * @param {string} sid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartBySid: async (sid, options = {}) => {
            // verify required parameter 'sid' is not null or undefined
            assertParamExists('getCartBySid', 'sid', sid);
            const localVarPath = `/cart-api/v2/cart/{sid}`
                .replace(`{${"sid"}}`, encodeURIComponent(String(sid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary DELETE cart-api/v2/cart/remove-coupon/{couponCode}
         * @param {string} couponCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCoupon: async (couponCode, options = {}) => {
            // verify required parameter 'couponCode' is not null or undefined
            assertParamExists('removeCoupon', 'couponCode', couponCode);
            const localVarPath = `/cart-api/v2/cart/remove-coupon/{couponCode}`
                .replace(`{${"couponCode"}}`, encodeURIComponent(String(couponCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary DELETE cart-api/v2/cart/{sid}/remove-coupon/{couponCode}
         * @param {string} sid
         * @param {string} couponCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCouponWithSid: async (sid, couponCode, options = {}) => {
            // verify required parameter 'sid' is not null or undefined
            assertParamExists('removeCouponWithSid', 'sid', sid);
            // verify required parameter 'couponCode' is not null or undefined
            assertParamExists('removeCouponWithSid', 'couponCode', couponCode);
            const localVarPath = `/cart-api/v2/cart/{sid}/remove-coupon/{couponCode}`
                .replace(`{${"sid"}}`, encodeURIComponent(String(sid)))
                .replace(`{${"couponCode"}}`, encodeURIComponent(String(couponCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary PATCH cart-api/v2/cart/add-coupon/{couponCode}
         * @param {string} couponCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCoupon(couponCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCoupon(couponCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary PATCH cart-api/v2/cart/{sid}/add-coupon/{couponCode}
         * @param {string} sid
         * @param {string} couponCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCouponWithSid(sid, couponCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCouponWithSid(sid, couponCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary PATCH cart-api/v2/cart/{sid}/add-savingsplan-article/{articleId}
         * @param {string} sid
         * @param {string} articleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSavingsPlanArticle(sid, articleId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSavingsPlanArticle(sid, articleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary PATCH cart-api/v2/cart/{sid}/set-article-quantity-command
         * @param {string} sid
         * @param {ChangeArticleQuantityRequestV2} changeArticleQuantityRequestV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeArticleQuantity(sid, changeArticleQuantityRequestV2, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeArticleQuantity(sid, changeArticleQuantityRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary DELETE cart-api/v2/cart/{sid}/delete-savingsplan-article
         * @param {string} sid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSavingsPlanArticle(sid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSavingsPlanArticle(sid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary GET cart-api/v2/cart/{sid}
         * @param {string} sid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCartBySid(sid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCartBySid(sid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary DELETE cart-api/v2/cart/remove-coupon/{couponCode}
         * @param {string} couponCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCoupon(couponCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCoupon(couponCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary DELETE cart-api/v2/cart/{sid}/remove-coupon/{couponCode}
         * @param {string} sid
         * @param {string} couponCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCouponWithSid(sid, couponCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCouponWithSid(sid, couponCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends BaseAPI {
    /**
     *
     * @summary PATCH cart-api/v2/cart/add-coupon/{couponCode}
     * @param {string} couponCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    addCoupon(couponCode, options) {
        return DefaultApiFp(this.configuration).addCoupon(couponCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary PATCH cart-api/v2/cart/{sid}/add-coupon/{couponCode}
     * @param {string} sid
     * @param {string} couponCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    addCouponWithSid(sid, couponCode, options) {
        return DefaultApiFp(this.configuration).addCouponWithSid(sid, couponCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary PATCH cart-api/v2/cart/{sid}/add-savingsplan-article/{articleId}
     * @param {string} sid
     * @param {string} articleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    addSavingsPlanArticle(sid, articleId, options) {
        return DefaultApiFp(this.configuration).addSavingsPlanArticle(sid, articleId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary PATCH cart-api/v2/cart/{sid}/set-article-quantity-command
     * @param {string} sid
     * @param {ChangeArticleQuantityRequestV2} changeArticleQuantityRequestV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    changeArticleQuantity(sid, changeArticleQuantityRequestV2, options) {
        return DefaultApiFp(this.configuration).changeArticleQuantity(sid, changeArticleQuantityRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary DELETE cart-api/v2/cart/{sid}/delete-savingsplan-article
     * @param {string} sid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteSavingsPlanArticle(sid, options) {
        return DefaultApiFp(this.configuration).deleteSavingsPlanArticle(sid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary GET cart-api/v2/cart/{sid}
     * @param {string} sid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCartBySid(sid, options) {
        return DefaultApiFp(this.configuration).getCartBySid(sid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary DELETE cart-api/v2/cart/remove-coupon/{couponCode}
     * @param {string} couponCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    removeCoupon(couponCode, options) {
        return DefaultApiFp(this.configuration).removeCoupon(couponCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary DELETE cart-api/v2/cart/{sid}/remove-coupon/{couponCode}
     * @param {string} sid
     * @param {string} couponCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    removeCouponWithSid(sid, couponCode, options) {
        return DefaultApiFp(this.configuration).removeCouponWithSid(sid, couponCode, options).then((request) => request(this.axios, this.basePath));
    }
}

export { DefaultApi, DefaultApiAxiosParamCreator, DefaultApiFp };
//# sourceMappingURL=api.js.map
